import React, { useState, useEffect } from 'react';
import Select from '../ui/Select';
import Input from '../ui/Input';
import Button from '../ui/Button';
import Icon from '../AppIcon';

const GlobalFilterBar = ({ onFilterChange }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [filters, setFilters] = useState({
    department: '',
    dateRange: { start: '', end: '' },
    employmentType: ''
  });

  const departmentOptions = [
    { value: '', label: 'All Departments' },
    { value: 'hr', label: 'Human Resources' },
    { value: 'finance', label: 'Finance' },
    { value: 'operations', label: 'Operations' },
    { value: 'it', label: 'Information Technology' },
    { value: 'legal', label: 'Legal & Compliance' },
    { value: 'admin', label: 'Administration' }
  ];

  const employmentTypeOptions = [
    { value: '', label: 'All Employment Types' },
    { value: 'permanent', label: 'Permanent' },
    { value: 'contract', label: 'Contract' },
    { value: 'casual', label: 'Casual' },
    { value: 'temporary', label: 'Temporary' }
  ];

  useEffect(() => {
    const savedFilters = localStorage.getItem('pngHrFilters');
    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);
      setFilters(parsed);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('pngHrFilters', JSON.stringify(filters));
    if (onFilterChange) {
      onFilterChange(filters);
    }
  }, [filters, onFilterChange]);

  const handleDepartmentChange = (value) => {
    setFilters(prev => ({ ...prev, department: value }));
  };

  const handleEmploymentTypeChange = (value) => {
    setFilters(prev => ({ ...prev, employmentType: value }));
  };

  const handleDateChange = (field, value) => {
    setFilters(prev => ({
      ...prev,
      dateRange: { ...prev?.dateRange, [field]: value }
    }));
  };

  const handleReset = () => {
    const resetFilters = {
      department: '',
      dateRange: { start: '', end: '' },
      employmentType: ''
    };
    setFilters(resetFilters);
    localStorage.removeItem('pngHrFilters');
  };

  const hasActiveFilters = filters?.department || filters?.dateRange?.start || filters?.dateRange?.end || filters?.employmentType;

  return (
    <div className="sticky top-16 bg-card border-b border-border z-100 transition-smooth">
      <div className="px-6 py-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <Icon name="Filter" size={20} color="var(--color-primary)" />
            <h3 className="font-heading font-semibold text-foreground">Filters</h3>
            {hasActiveFilters && (
              <span className="px-2 py-1 text-xs font-caption bg-primary text-primary-foreground rounded-md">
                Active
              </span>
            )}
          </div>
          <div className="flex items-center gap-2">
            {hasActiveFilters && (
              <Button
                variant="ghost"
                size="sm"
                onClick={handleReset}
                iconName="RotateCcw"
                iconPosition="left"
              >
                Reset
              </Button>
            )}
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="lg:hidden flex items-center justify-center w-8 h-8 rounded-md hover:bg-muted transition-smooth"
              aria-label={isExpanded ? 'Collapse filters' : 'Expand filters'}
            >
              <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} color="currentColor" />
            </button>
          </div>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 ${isExpanded ? 'block' : 'hidden lg:grid'}`}>
          <Select
            label="Department"
            options={departmentOptions}
            value={filters?.department}
            onChange={handleDepartmentChange}
            placeholder="Select department"
          />

          <Input
            type="date"
            label="Start Date"
            value={filters?.dateRange?.start}
            onChange={(e) => handleDateChange('start', e?.target?.value)}
          />

          <Input
            type="date"
            label="End Date"
            value={filters?.dateRange?.end}
            onChange={(e) => handleDateChange('end', e?.target?.value)}
            min={filters?.dateRange?.start}
          />

          <Select
            label="Employment Type"
            options={employmentTypeOptions}
            value={filters?.employmentType}
            onChange={handleEmploymentTypeChange}
            placeholder="Select type"
          />
        </div>
      </div>
    </div>
  );
};

export default GlobalFilterBar;